import { useQuery } from '@tanstack/react-query';
import { useState, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { RightCircleOutlined, DownCircleOutlined } from '@ant-design/icons';
import { StyledTable } from '../shared';
import { tableColumns } from './helpers';
import { Loading } from 'Components';
import Jobs from '../Jobs';
import moment from 'moment';

const UNIX_EPOCH = moment(-1);

const fetchTasks = async (orchestrator) => {
  const res = await orchestrator.getSchedules();
  return JSON.parse(res);
};

const fetchFunctionalities = async (orchestrator) => {
  const res = await orchestrator.getFunctionalities();
  return JSON.parse(res);
};

const processTaskData = (taskData = [], functionalityData = [], refetch) => {
  const parsed = taskData.map((item) => {
    return {
      ...item,
      refetch,
      key: item.uid,
      functionality: functionalityData.find((f) => (f.name === item.functionalityName && f.version === item.functionalityVersion)),
      active: item.crons.find(({ nextRun }) => moment(nextRun).isAfter(UNIX_EPOCH)) || false,
      recurring: item.crons.find(({ cron, runOnce }) => (cron.value !== undefined && runOnce === false)) || false,
      nextRun: item.crons.filter(({ nextRun }) => moment(nextRun).isAfter(moment())).map(({ nextRun }) => nextRun),
    }
  })

  return _.orderBy(parsed, ['created'], ['desc'])
}

const TaskTable = ({ orchestrator }) => {
  const { location } = useHistory();
  const [expandedRowKey, setExpandedRowKey] = useState(location.state);
  const [showConfig, setShowConfig] = useState(false);

  const { data: tasksData, isLoading: tasksLoading, refetch } = useQuery(
    ['pipelines.tasks'],
    () => fetchTasks(orchestrator),
    { refetchInterval: 60000 }
  );

  const { data: functionalitiesData, isLoading: functionalitiesLoading } = useQuery(
    ['pipelines.functionalities'],
    () => fetchFunctionalities(orchestrator)
  );

  const processedData = useMemo(
    () => processTaskData(tasksData, functionalitiesData, refetch),
    [tasksData, functionalitiesData, refetch]
  );

  if (tasksLoading || functionalitiesLoading) return <Loading />;

  return (
    <StyledTable
      columns={tableColumns(setExpandedRowKey, setShowConfig)}
      expandable={{
        expandRowByClick: false,
        expandedRowKeys: [expandedRowKey],
        expandedRowRender: (task, index, indent, expanded) =>
          expanded ? <Jobs task={task} orchestrator={orchestrator} showConfig={showConfig} /> : null,
        expandIcon: ({ expanded, onExpand, record }) => (
          expanded ? (
            <DownCircleOutlined onClick={(e) => {
              setShowConfig(false);
              setExpandedRowKey(undefined);
              onExpand(record, e);
            }} />
          ) : (
            <RightCircleOutlined onClick={(e) => {
              setExpandedRowKey(record.key);
              onExpand(record, e);
            }} />
          )
        )
      }}
      dataSource={processedData || []}
    />
  );
};

export default TaskTable;
